/**
 * Envelope uniforme que devuelve keystoreman-console-api.
 * OJO: el campo es `statusCode`, NO `status`.
 *
 * Excepcion: si falta el header Authorization el API responde 403 con
 * `{ "detail": "Not authenticated" }` FUERA de este envelope.
 * Los errores de validacion llegan como 400 (no 422).
 */
export interface IServerResponse<T = any> {
  data?: T;
  error: any;
  message: string;
  statusCode: number;
}

/** Respuesta cruda de FastAPI cuando falta el header Authorization (403). */
export interface INotAuthenticatedResponse {
  detail: string;
}

/** Campos de paginacion que acompanian a las listas (respuesta en camelCase). */
export interface IPagination {
  total: number;
  page: number;
  pageSize: number;
}

/** El API NO devuelve totalPages: se calcula en el cliente. */
export const calculateTotalPages = (total: number, pageSize: number): number =>
  pageSize > 0 ? Math.ceil(total / pageSize) : 0;

/** Tope maximo de `page_size` aceptado por el API. */
export const MAX_PAGE_SIZE = 100;
